<div class="m-5">
  <div class="flex w-full p-[20px]">
    <div class="grow">
      <div [style]="messageBoxStyle">
        <div class="flex py-8 mt-3 px-3 items-center" id="banner">
          <button aria-label="Decrement Dashboard Message" [disabled]="studentMessageIter === 0" (click)="decrementMessages()" [ngClass]="studentMessageIter !== 0? 'flex-shrink justify-self-start text-white h-8 w-8 rounded-full flex justify-center items-center': 'flex-shrink justify-self-start text-transparent h-8 w-8 rounded-full flex justify-center items-center'">
            <fa-icon [icon]="faChevronLeft" />
          </button>
          <div class="flex-grow ml-3 text-lg">
            @if (studentMessages.length > 0) {
              <div class="sm:max-w-[200px] lg:max-w-[650px] max-h-[150px] line-clamp-2">
                {{studentMessages[studentMessageIter].msg}}
              </div>
            }
            @if (studentMessages.length === 0) {
              <div class="sm:max-w-[200px] lg:max-w-[650px] max-h-[150px] line-clamp-2">
                No announcements!
              </div>
            }
            @if (studentMessages.length > 1) {
              <div class="flex -mb-5">
                @for (message of studentMessages; track message; let i = $index) {
                  <button (click)="studentMessageIter = i" [ngClass]="studentMessageIter === i? 'rounded-full h-2 w-2 bg-gray-600 mr-1 mt-8': 'rounded-full h-2 w-2 bg-gray-200 mr-1 mt-8'">
                  </button>
                }
              </div>
            }
          </div>
          @if (studentMessageIter !== studentMessages.length-1 && studentMessages.length !== 0) {
            <button (click)="incrementMessages()" class="flex-shrink justify-self-end text-black h-8 w-8 rounded-full flex justify-center items-center hover:bg-gray-200">
              <fa-icon [icon]="faChevronRight" />
            </button>
          }
        </div>
      </div>
      <div class="mt-[74px] px-[12px]">
        <div class="flex justify-between items-center">
          <span class="font-semibold text-[18px]">Upcoming Assessments</span>
          <button (click)="router.navigate(['dashboard/assessments'])" class="flex items-center text-[14px] text-[#121212] px-[12px] py-[6px] rounded-[8px] hover:bg-[#D6DBE0]">
            View all Assessments
            <fa-icon class="text-[12px] ml-1" [icon]="faChevronRight" />
          </button>
        </div>
        <div class="grid grid-cols-6 text-[#637381] text-[14px] font-semibold mt-[24px]">
          <div class="col-span-2">
            Title
          </div>
          <div>
            Due Date
          </div>
          <div>
            Type
          </div>
          <div>
            Status
          </div>
          <div>

          </div>
        </div>
        @for (exam of upcomingAssessments; track exam) {
          <div class="grid grid-cols-6 mt-[24px] text-[14px] text-[#121212] min-h-[41px]">
            <div class="col-span-2 flex flex-col justify-center">
              {{exam.exam_title}}
              <div class="text-[12px] text-[#637381] mt-[4px]">
                10 Questions
              </div>
            </div>
            <div class="flex flex-col justify-center">
              {{ exam.due_time | date: 'MM/dd/y'}}
              <div [ngClass]="getDaysRemaining(exam.finish_by) > 1? 'text-[12px] text-[#637381] mt-[4px]':'text-[12px] text-[#CC0033] mt-[4px]'">
                {{getDaysRemaining(exam.due_time)}} day(s) left
              </div>
            </div>
            <div class="flex items-center">
              {{ exam.type }}
            </div>
            <div class="flex items-center text-[12px]">
              <ExamStatusComponent [exam]="exam" />
            </div>
            @if (exam.status === 'not_started') {
              <button (click)="startAssessment(exam.exam_id)" class="px-[20px] py-[10px] rounded-[8px] bg-[#CC0033] text-white w-[140px] text-[14px] hover:bg-[#940025]">
                Start
              </button>
            }
            @if (exam.status === 'scored') {
              <button class="px-[20px] py-[10px] rounded-[8px] hover:bg-[#F2EFFE] border hover:border-[#940025] hover:text-[#940025] border-[#C03] text-[#C03] w-[140px] text-[14px]">
                View Score
              </button>
            }
            @if (exam.status !== 'not_started' && exam.status !== 'scored') {
              <button disabled class="px-[20px] py-[10px] rounded-[8px] bg-[#FF4775] text-white w-[140px] text-[14px]">
                No Action
              </button>
            }
          </div>
        }
      </div>
    </div>
    @if (!isScreenSmall) {
      <div class="rounded-[8px] w-[300px] h-[584px] bg-[#F4F6F8] px-[20px] flex flex-col justify-between ml-[20px]">
        <calendar [exams]="examListResponse" />
        <div>
          <h1><b>Recent Results</b></h1>
          <div class="my-[16px]">
            <div class="flex flex-col gap-[8px] text-[14px]">
              <p>Nothing to show</p>
            </div>
            <div class="mt-[16px] flex justify-center items-center">
              <button (click)="router.navigate(['dashboard/gradebook'])" class="rounded-[8px] border border-[#919EABCC] py-[10px] px-[20px] text-[#212B36] text-[14px] font-bold hover:border-[#718293] hover:bg-[#D6DBE0] w-[175px]">
                View Gradebook
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
